import styled from '@emotion/styled';
import { Colors, helperAbsoluteFill, media } from '@utex/ui-kit';

export const Container = styled('div')`
  --gap: 4rem;
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  @media ${media.phonablet} {
    --gap: 1.6rem;
  }
`;

export const Sidebar = styled('div')`
  position: relative;

  @media ${media.phonablet} {
    padding: 0 var(--gap) 2rem;
  }

  @media ${media.tablesktop} {
    flex-shrink: 0;
    width: ${(406 / 960) * 100}%;
    border-right: 1px solid ${Colors.ut.border10};
  }
`;

export const Menu = styled('div')`
  ${helperAbsoluteFill};
  overflow: auto;
  -webkit-overflow-scrolling: touch;

  @media ${media.phonablet} {
    display: none;
  }
`;

export const Mainbar = styled('div')`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-width: 0;
  padding: 3rem var(--gap) var(--gap);

  @media ${media.phonablet} {
    flex-direction: column;
    padding-top: 0;
  }
`;

export const Form = styled('form')`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  width: 100%;
`;

export const FormContent = styled('div')`
  flex-grow: 1;
`;

export const FormFooter = styled('div')`
  flex-shrink: 0;
  display: flex;
  margin-top: 2rem;

  @media ${media.phonablet} {
    flex-direction: column-reverse;
    text-align: center;
  }
`;
